import { render, staticRenderFns } from "./MoneyDetailsTable.vue?vue&type=template&id=032c8674&scoped=true&"
import script from "./MoneyDetailsTable.vue?vue&type=script&lang=js&"
export * from "./MoneyDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./MoneyDetailsTable.vue?vue&type=style&index=0&id=032c8674&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032c8674",
  null
  
)

export default component.exports